/**
 * Rangos para colorear el estado de los hidrófonos (tabla de alertas).
 * Valor <= danger → rojo; <= warning → amarillo; mayor → verde.
 * Batería y panel arrancan con los mismos rangos que el alimentador, pero viven
 * aparte para poder ajustarlos sin afectarlo.
 */
export const HYDRO_STATUS_THRESHOLDS = {
  battery: { danger: 11.5, warning: 12.5 },
  panel: { danger: 12, warning: 15 },
  /** Señal en dB: valores propuestos, pendientes de confirmar. */
  signal: { danger: 8, warning: 15 }
};

/** Colores del estado de los hidrófonos (mismos que el alimentador en alertas). */
export const HYDRO_STATUS_COLORS = {
  success: "#27c24c",
  warning: "#f7d800",
  danger: "#ff0000"
};

/** Tipo de indicador numerico del hidrófono. */
export type HydroStatusType = "battery" | "panel" | "signal";
